import React from 'react'
import next from '../../Images/next.png'
import './Menu.scss';
import { useState } from 'react';
import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom';

export default function Menu({ setUserSession, navigateTo, setShowMenu, ServicesData, showsetNotification, showsetNotificationType, setUpdateApp }) {
    const [showCategories, setshowCategories] = useState(false);
    const [Render, setRender] = useState();
    const [showMakers, setshowMakers] = useState(false);
    const navigate = useNavigate()

    const [closMenuAnime, setclosMenuAnime] = useState(false);
    const [ShowSearch, setShowSearch] = useState(false);
    const [ZipCode, setZipCode] = useState(null);
    const [ServicesDataNew, setServicesDataNew] = useState([]);
    const [ServicesDataNewSubCategory, setServicesDataNewSubCategory] = useState([]);

    useEffect(() => {
        let arrray = []
        for (let index = 0; index < ServicesData.length; index++) {
            for (let index2 = 0; index2 < ServicesData[index].sub_services.length; index2++) {
                // console.log(arrray);
                arrray.push(ServicesData[index].sub_services[index2])
            }
        }
        setServicesDataNew(arrray)
        setServicesDataNewSubCategory(arrray);


    }, []);
    return (
        <div className="Menu">
            <div className={closMenuAnime ? "MenuMainSub MenuMainSubAnime" : "MenuMainSub"}>
                <div className="MenuHeaderSearch">
                    <div className="MenuHeaderSearchMain">

                        <h1>HandyBy</h1>
                        <input placeholder='What are you looking for' type="text"
                            onClick={() => {
                                setShowSearch(true)
                                // window.scrollTo(0, 0)
                            }}
                            onChange={(a) => {
                                setShowSearch(true)
                                setRender(a => !a)
                                let newnew = ServicesDataNewSubCategory.filter((a2 => a2.toLowerCase().includes(a.target.value.toLocaleLowerCase())))
                                setRender(a => !a)
                                setServicesDataNew(newnew)
                            }}
                        />
                        <img onClick={() => {
                            setclosMenuAnime(true)
                            setRender(a => !a)
                            setTimeout(() => {
                                setShowMenu(false)
                            }, 300);
                        }} className="MenuHeaderSearchImg" src={require(`../../Images/closeMenu.png`)} />
                        {ShowSearch ?
                            <div className="HomePageTopBannerTextInputSearchResults" >
                                <div className="HomePageTopBannerTextInputSearchResultsList">
                                    {

                                        ServicesDataNew.length > 0 ?
                                            ServicesDataNew.map((A, Index) =>
                                                <a href={`/request-service?service=${A}`} className="HomePageTopBannerTextInputSearchResultsListBox">
                                                    <img className="HomePageTopBannerTextInputSearchResultsListBoxImg" src={require(`../../Images/search.png`)} alt="Chimney Cleaning" />
                                                    <a href={`/request-service?service=${A}${ZipCode ? `&zipcode=${ZipCode}` : "noe"}`}>{A}</a>
                                                </a>
                                            )
                                            :
                                            <div className="HomePageTopBannerTextInputSearchResultsListBox">
                                                <img className="HomePageTopBannerTextInputSearchResultsListBoxImg" src={require(`../../Images/search.png`)} />
                                                <a >No results</a>
                                            </div>
                                    }

                                </div>

                            </div>
                            : null}
                    </div>
                    <div className="MenuHeaderSearchShape">
                        <div className="CategoryNavShapeInside"></div>
                    </div>
                </div>
                <div className="MenuMainSubvUser" onMouseDown={() => {
                    setShowSearch(false)
                }}>
                    <h1>Account Center</h1>
                    {localStorage.getItem("UserSessionn") ?
                        <span>
                            <button onClick={() => {
                                setShowMenu(false)
                                navigate('/account/dashboard')
                            }}>My Account</button>
                            <button onClick={() => {
                                localStorage.removeItem("UserSessionn")
                                setUserSession({})
                                setUpdateApp(a => !a)
                                setclosMenuAnime(true)
                                setRender(a => !a)
                                setTimeout(() => {
                                    setShowMenu(false)
                                }, 300);
                                showsetNotificationType('logout')
                                showsetNotification(true)
                                navigate('/')
                                // window.location.reload();
                            }}>Log out</button>
                        </span>
                        :
                        <span>
                            <a href="/login">Login</a>
                            <a href="/sign-up">Sign up</a>
                        </span>
                    }
                </div>
                <div className="MenuMain" onMouseDown={() => {
                    setShowSearch(false)
                }}>
                    <div className="MenuMainBox">
                        <a href='/'>Home</a>
                    </div>
                    <div className="MenuMainBox" onClick={() => {
                        setshowMakers(true)
                    }}>
                        <h1 >Categories</h1>
                        <img src={next} alt="" />
                    </div>
                    <div className="MenuMainBox" onClick={() => {
                        setshowCategories(true)
                    }}>
                        <h1>Top Companies</h1>
                        <img src={next} alt="" />
                    </div>
                </div>

                <div className="MenuMainSubFooter" onMouseDown={() => {
                    setShowSearch(false)
                }}>
                    <h1>Popular projects near you</h1>
                    <div className="MenuMainSubFooterList">

                        <a href="/category/Chimney-Fireplace" className="MenuMainSubFooterBox">
                            <img src={require(`../../Images/1-chimney.jpg`)} />
                            <h1>Chimney Sweep</h1>
                        </a>
                        <a href="/category/Garage-Door" className="MenuMainSubFooterBox">
                            <img src={require(`../../Images/1-garage.jpg`)} />
                            <h1>Garage Door</h1>
                        </a>
                        <a href="/category/Locksmith" className="MenuMainSubFooterBox">
                            <img src={require(`../../Images/1-locksmith.jpg`)} />
                            <h1>Locksmith</h1>
                        </a>
                        <a href="/category/Roofing" className="MenuMainSubFooterBox">
                            <img src={require(`../../Images/1-roofing.jpg`)} />
                            <h1>Roofing</h1>
                        </a>
                        <a href="/category/Air-Duct" className="MenuMainSubFooterBox">
                            <img src={require(`../../Images/1-airduct.jpg`)} />
                            <h1>Air Duct</h1>
                        </a>
                        <a href="/category/Dryer-Vent" className="MenuMainSubFooterBox">
                            <img src={require(`../../Images/1-dryervent.jpg`)} />
                            <h1>Dryer Vent</h1>
                        </a>
                        <a href="/category/HVAC" className="MenuMainSubFooterBox">
                            <img src={require(`../../Images/1-hvac.jpg`)} />
                            <h1>HVAC</h1>
                        </a>
                        <a href="/category/Insulation" className="MenuMainSubFooterBox">
                            <img src={require(`../../Images/1-insulation.jpg`)} />
                            <h1>Insulation</h1>
                        </a>
                        <a href="/start-project" className="MenuMainSubFooterBoxLast">
                            View All Services
                        </a>
                    </div>
                    <span>

                        <a href="/start-project">View All</a>
                        <a className='MenuMainSubFooterStartPrroject' href="/start-project"> <img src={require(`../../Images/construction.png`)} alt="Chimney Cleaning" /> Create Project</a>
                    </span>

                </div>

                <div className="MenuMainSubDisableSearch" onMouseDown={() => {
                    setShowSearch(false)
                }}></div>

                {/* showCategories */}
                {showMakers ?
                    <div className="MenuMakers" onMouseDown={() => {
                        setShowSearch(false)
                    }}>
                        <div className="MenuMakersHeader">
                            <img src={next} alt="" onClick={() => {
                                setshowMakers(false)
                            }} />
                            <h1 onClick={() => {
                                // navigateTo("")
                            }}>Categories</h1>˝
                        </div>
                        <div className="MenuMakersList">
                            <div className="MenuMakersListBox">
                                <a href='/category/Air-Duct'>Air Duct</a>
                            </div>
                            <div className="MenuMakersListBox">
                                <a href='/category/Dryer-Vent'>Dryer Vent</a>
                            </div>
                            <div className="MenuMakersListBox">
                                <a href='/category/HVAC'>HVAC</a>
                            </div>
                            <div className="MenuMakersListBox">
                                <a href='/category/Chimney'>Chimney</a>
                            </div>
                            <div className="MenuMakersListBox">
                                <a href='/category/Roofing'>Roofing</a>
                            </div>
                        </div>
                    </div>
                    : null}
                {showCategories ?
                    <div className="MenuMakers" onMouseDown={() => {
                        setShowSearch(false)
                    }}>
                        <div className="MenuMakersHeader">
                            <img src={next} alt="" onClick={() => {
                                setshowCategories(false)
                            }} />
                            <h1 onClick={() => {
                                // navigateTo("")
                            }}>Categories</h1>
                        </div>
                        <div className="MenuMakersList">
                            <div className="MenuMakersListBox">
                                <a href='/pros/Air-Duct'>Air Duct</a>
                            </div>
                            <div className="MenuMakersListBox">
                                <a href='/pros/Dryer-Vent'>Dryer Vent</a>
                            </div>
                            <div className="MenuMakersListBox">
                                <a href='/pros/HVAC'>HVAC</a>
                            </div>
                            <div className="MenuMakersListBox">
                                <a href='/pros/Chimney'>Chimney</a>
                            </div>
                            <div className="MenuMakersListBox">
                                <a href='/pros/Roofing'>Roofing</a>
                            </div>
                        </div>

                    </div>
                    : null}
            </div>
            <div onClick={() => {
                setclosMenuAnime(true)
                setRender(a => !a)
                setTimeout(() => {
                    setShowMenu(false)
                }, 300);
            }} className="MenuColorBack"></div>
        </div>
    )
}



